import { createUseQueryHook } from '@iheartjane/react-query-utils';

import { fetchCheckoutRequirements } from './quickCheckout.api';
import type {
  FetchCheckoutRequirementsRequest,
  StoreCheckoutRequirements,
} from './quickCheckout.types';

const quickCheckoutQueryKeys = {
  checkoutRequirements: ({
    storeId,
    reservationMode,
  }: Omit<FetchCheckoutRequirementsRequest, 'jwt'>) =>
    ['checkoutRequirements', storeId, reservationMode] as const,
};

export const useCheckoutRequirements = createUseQueryHook<
  FetchCheckoutRequirementsRequest,
  StoreCheckoutRequirements
>(
  fetchCheckoutRequirements,
  quickCheckoutQueryKeys.checkoutRequirements,
  ({ storeId, jwt }) => !!jwt && !!storeId
);
